import { ref } from 'vue'
import { teamApi } from '@/services/api'

/**
 * @deprecated use useInfiniteyOffice instead 
 */
export const useInfiniteTeam = ({ values, limit = ref(30), page = ref(0) }) => {
  // <b-autocomplete-infity class="w-full" @get-more-data="getMoreResources" :list="resourceAutoComplete.list"
  // :selected="project.contributors" @add-selected="addSalesContributor"
  // @remove-selected="removeSalesContributor"
  // :haveMore="resourceAutoComplete.haveMore && !resourceAutoComplete.loading">
  // <template #custom-list="{ selectItem, list }">
  const list = ref([])
  const haveMore = ref(true)
  const loading = ref(false)
  const select = (selected) => {
    const teamIndex = values.findIndex(team => team._id === selected._id)
    if (teamIndex > -1)
      return values.splice(teamIndex, 1)
    values.push(selected)
  }
  const getMoreData = async (options) => {
    if (options.new) {
      page.value = 0
      haveMore.value = true
    }
    loading.value = true
    const teamRequest = await teamApi.filter({ page: page.value, limit: limit.value, display: options.search }).promise
    loading.value = false
    haveMore.value = teamRequest.count.currentPage < teamRequest.count.totalPages
    list.value = options.new ? teamRequest.docs : [...list.value, ...teamRequest.docs]
    page.value++
  }

  const remove = (toRemove) => {
    const foundIndex = values.findIndex(team => team._id === toRemove._id)
    if (foundIndex === -1)
      return

    values.splice(foundIndex, 1)
  }

  return {
    haveMore,
    getMoreData,
    remove,
    select,
    list,
    values,
  }
}


// export const useInfinityOffice = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]) }) => {
//   const haveMore = ref(true)
//   const getMoreData = async () => {
//     try {
//       isLoading.value = true
//       const searchRequest = officeApi.filter({ page: page.value, limit: limit.value, display: search.value })
//       const searchResponse = await searchRequest.promise
//       haveMore.value = searchResponse.count.hasNextPage
//       list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]
//       return searchResponse
//     }
//     catch (err) {
//       console.log('err', err)
//     }
//     finally {
//       isLoading.value = false
//     }
//   }
//   return {
//     search,
//     limit,
//     page,
//     haveMore,
//     getMoreData,
//     list,
//     isLoading,
//   }
// }


export const useInfinityTeam = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]) }) => {
  const haveMore = ref(true)
  const total = ref(0)
  const getMoreData = async () => {
    try {
      console.log('search', search.value)
      isLoading.value = true
      const searchRequest = teamApi.filter({ page: page.value, limit: limit.value, display: search.value })
      const searchResponse = await searchRequest.promise
      console.log('searchResponse', searchResponse)
      haveMore.value = searchResponse.count.hasNextPage
      list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]
      total.value = searchResponse.count.total;
      return searchResponse
    }
    catch (err) {
      console.log('err', err)
    }
    finally {
      isLoading.value = false
    }
  }
  return {
    search,
    limit,
    page,
    haveMore,
    getMoreData,
    list,
    isLoading,
  }
}
